import { useEffect } from 'react';

function useMediaChange(settings) {
  const change = media =>
    (settings.find(item => item.query === media) || {}).onChange() ||
    (() => {})();
  const handleMediaStatusChange = event => {
    if (event.matches) {
      change(event.media);
    }
  };

  useEffect(() => {
    const mediaQueryList = settings.map(item => window.matchMedia(item.query));

    mediaQueryList.forEach(item => item.addListener(handleMediaStatusChange));

    return () => {
      mediaQueryList.forEach(item =>
        item.removeListener(handleMediaStatusChange)
      );
    };
  }, [settings]);
}

export default useMediaChange;
